/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Badge_BuildInputs */

const id_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const ms_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaan`)
};

const da_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const de_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const en_us2_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const es_es2_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación`)
};

const es_mx2_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación`)
};

const fil_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const fr_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilation`)
};

const it_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const hu_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const nl_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const no_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const pl_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompilacja`)
};

const pt_br2_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const pt_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilação`)
};

const ro_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilare`)
};

const fi_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koontiversio`)
};

const sv_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygge`)
};

const vi_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản dựng`)
};

const tr_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapı`)
};

const cs_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sestavení`)
};

const bg_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компилация`)
};

const ru_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сборка`)
};

const uk_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Збірка`)
};

const ar_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنية`)
};

const hi_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिल्ड`)
};

const th_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บิลด์`)
};

const ja_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビルド`)
};

const zh_cn2_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`构建版本`)
};

const zh_hant1_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建置版本`)
};

const ko_home_pulse_badge_build = /** @type {(inputs: Home_Pulse_Badge_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빌드`)
};

/**
* | output |
* | --- |
* | "Build" |
*
* @param {Home_Pulse_Badge_BuildInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_badge_build = /** @type {((inputs?: Home_Pulse_Badge_BuildInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Badge_BuildInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_badge_build(inputs)
	if (locale === "ms") return ms_home_pulse_badge_build(inputs)
	if (locale === "da") return da_home_pulse_badge_build(inputs)
	if (locale === "de") return de_home_pulse_badge_build(inputs)
	if (locale === "en-US") return en_us2_home_pulse_badge_build(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_badge_build(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_badge_build(inputs)
	if (locale === "fil") return fil_home_pulse_badge_build(inputs)
	if (locale === "fr") return fr_home_pulse_badge_build(inputs)
	if (locale === "it") return it_home_pulse_badge_build(inputs)
	if (locale === "hu") return hu_home_pulse_badge_build(inputs)
	if (locale === "nl") return nl_home_pulse_badge_build(inputs)
	if (locale === "no") return no_home_pulse_badge_build(inputs)
	if (locale === "pl") return pl_home_pulse_badge_build(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_badge_build(inputs)
	if (locale === "pt") return pt_home_pulse_badge_build(inputs)
	if (locale === "ro") return ro_home_pulse_badge_build(inputs)
	if (locale === "fi") return fi_home_pulse_badge_build(inputs)
	if (locale === "sv") return sv_home_pulse_badge_build(inputs)
	if (locale === "vi") return vi_home_pulse_badge_build(inputs)
	if (locale === "tr") return tr_home_pulse_badge_build(inputs)
	if (locale === "cs") return cs_home_pulse_badge_build(inputs)
	if (locale === "bg") return bg_home_pulse_badge_build(inputs)
	if (locale === "ru") return ru_home_pulse_badge_build(inputs)
	if (locale === "uk") return uk_home_pulse_badge_build(inputs)
	if (locale === "ar") return ar_home_pulse_badge_build(inputs)
	if (locale === "hi") return hi_home_pulse_badge_build(inputs)
	if (locale === "th") return th_home_pulse_badge_build(inputs)
	if (locale === "ja") return ja_home_pulse_badge_build(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_badge_build(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_badge_build(inputs)
	return ko_home_pulse_badge_build(inputs)
});
export { home_pulse_badge_build as "home.pulse.badge.build" }